var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"popup-header"},[_c('div',{staticClass:"close-icon",on:{"click":_vm.close}},[_c('img',{attrs:{"src":"//i0.hdslb.com/bfs/activity-plat/static/20240409/4fd3833722492cf2d9e284c3722f6329/qY29dSHfFI.svg"}})]),_vm._t("default")],2),_c('div',{staticClass:"header-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }